export class TidImportModel {
    fileData: string;
    fileName: string;
	contragentId: number;
	agreementId: number;
    acquirerId: number;
}